export const chainId = {
	ETHEREUM: 11155111,
	BINANCE: 97,
	POLYGON: 80002,
	AMOY: 80002
}
